module.exports = __webpack_public_path__ + "static/media/screen_main_only.1e561eff.svg";